var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.tenantUsers),function(item,n){return _c('div',{key:'CorrectionManager-'+n,staticClass:"d-flex align-items-center mb-2"},[_c('div',{staticClass:"flex-grow-1"},[_vm._v(" "+_vm._s(item.user.displayName)+" ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }